import React    from 'react';

class Base extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {
            className,
            onClick,
            children,
            isDisabled
        } = this.props;
        return (
            <button
                type            = "button"
                className       = { className }
                onClick         = { (e) => onClick(e) }
                disabled        = { isDisabled }
                ref             = 'BUTTON'
            >
                { children }
            </button>
        );
    }
}

export default Base;